export function getKeyByValue(enumType: any, value: string) {
    const valueIndex = Object.values(enumType).indexOf(value);
    return Object.keys(enumType)[valueIndex];
}

export function getValueByKey(enumType: any, key: any): any {
    const keyIndex = Object.keys(enumType).indexOf(key);
    return Object.values(enumType)[keyIndex];
}
